<script>
export default {
    name: "PendingInvestigations",

    data() {

        return {
            pendingInvestigations: [],
        };
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([ this.fetchPendingInvestigations(), ]).then(() => {
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { this.$root.loading=false; })
    },

    methods: {

        fetchPendingInvestigations() {

            let url = `Inpatient/GetWardRoundPendingLab`;

            return this.$http.get(url).then(response => {
                    this.pendingInvestigations=response.data;
                }).catch(() => { });
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap mx-2">
        <tail-address-header></tail-address-header>
        <div class="w-full text-center my-2">
            <h5 class="text-base font-medium uppercase">Pending Inpatient Investigations</h5>
        </div>
        <table class="table">
            <thead class="text-sm">
                <tr class="w-full flex">
                    <th class="flex-1 p-tiny">Date</th>
                    <th class="flex-1 p-tiny">MRN</th>
                    <th class="flex-1 p-tiny">IP File No</th>
                    <th class="flex-1 p-tiny">OP File No</th>
                    <th class="flex-1 p-tiny">DOB</th>
                    <th class="flex-1 p-tiny">Ward</th>
                    <th class="flex-1 p-tiny">Bed</th>
                    <th class="w-1/4 p-tiny">Payment Mode</th>
                    <th class="w-1/4 p-tiny">Investigation</th>
                    <th class="flex-1 p-tiny">Status</th>
                </tr>
            </thead>
            <tbody class="flex flex-col items-center text-sm">
                <tr class="w-full flex" 
                    v-for="(investigation,idx) in pendingInvestigations" :key="idx">
                    <td class="p-tiny flex-1">{{ investigation.date | dateFormat }}</td>
                    <td class="p-tiny flex-1">{{ investigation.names }}</td>
                    <td class="p-tiny flex-1">{{ investigation.patienT_ID }}</td>
                    <td class="p-tiny flex-1">{{ investigation.ipfileno || `-` }}</td>
                    <td class="p-tiny flex-1">{{ investigation.opfileno || `-` }}</td>
                    <td class="p-tiny flex-1">{{ investigation.dob |dateFormat }}</td>
                    <td class="p-tiny flex-1">{{ investigation.ward || `-` }}</td>
                    <td class="p-tiny flex-1">{{ investigation.bed || `-` }}</td>
                    <td class="p-tiny w-1/4">{{ investigation.pMode }}</td>
                    <td class="p-tiny w-1/4">{{ investigation.itemName }}</td>
                    <td class="p-tiny flex-1">{{ investigation.patientstatus }}</td>
                </tr>
                <tr class="w-full flex">
                    <td colspan="10" class="flex-1 p-1"></td>
                    <th class="w-1/5 p-1">Total: {{pendingInvestigations.length}}</th>
                </tr>
            </tbody>
        </table>
    </div>
</template>